var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9336_80886)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9336_80886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3332 82.4604H12.6704C12.1608 82.4597 11.6724 82.2568 11.3123 81.8962C10.9522 81.5357 10.75 81.047 10.75 80.5374V6.13694C10.7505 5.62701 10.9533 5.13812 11.3141 4.77771C11.6748 4.4173 12.1639 4.21484 12.6738 4.21484H70.3367C70.8459 4.21597 71.334 4.4189 71.6939 4.77916C72.0539 5.13943 72.2564 5.62767 72.257 6.13694V80.5374C72.2568 81.0475 72.054 81.5366 71.6933 81.8972C71.3325 82.2578 70.8433 82.4604 70.3332 82.4604Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9683 12.0818H15.9363V75.5528H66.9683V12.0818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4509 25.8534H21.647V23.411H37.4509V25.8534ZM61.3028 23.411H55.4186V25.8534H61.3028V23.411ZM50.9166 29.9615H21.6333V32.4056H50.9166V29.9615ZM61.3028 36.5129H21.6342V38.9552H61.3028V36.5129ZM44.5592 43.0634H21.6342V45.5057H44.5566L44.5592 43.0634ZM30.8927 62.7601H21.6461V65.2025H30.8927V62.7601ZM43.6366 62.7601H34.3909V65.2025H43.6392L43.6366 62.7601ZM52.8447 49.6156H21.6342V52.0579H52.8447V49.6156ZM57.2322 56.1661H21.6333V58.6076H57.2322V56.1661Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4721 14.7112H18.464V16.0635H64.4721V14.7112Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7796 7.68484H47.6235C47.6775 7.36068 47.706 7.03278 47.7089 6.70415C47.7084 5.04825 47.0503 3.46033 45.8793 2.2896C44.7082 1.11887 43.1201 0.461182 41.4642 0.461182C40.6442 0.460957 39.8322 0.622272 39.0746 0.93591C38.317 1.24955 37.6286 1.70936 37.0487 2.2891C36.4688 2.86883 36.0088 3.55713 35.6949 4.31467C35.3811 5.07222 35.2195 5.88417 35.2195 6.70415C35.2219 7.0328 35.2505 7.36073 35.305 7.68484H23.1573L18.4631 14.7112H64.4738L59.7796 7.68484ZM41.4633 8.88081C41.1779 8.88093 40.8953 8.82479 40.6316 8.71561C40.3678 8.60644 40.1282 8.44636 39.9264 8.24453C39.7246 8.04271 39.5645 7.80309 39.4553 7.53936C39.3461 7.27564 39.29 6.99299 39.2901 6.70756C39.2898 6.42191 39.3457 6.139 39.4548 5.87498C39.5638 5.61097 39.7238 5.37103 39.9257 5.16889C40.1275 4.96674 40.3672 4.80635 40.631 4.69688C40.8949 4.58741 41.1777 4.53101 41.4633 4.5309C41.7489 4.53068 42.0318 4.58671 42.2957 4.69582C42.5596 4.80492 42.7994 4.96496 43.0015 5.16677C43.2035 5.36859 43.3638 5.60824 43.4733 5.87202C43.5827 6.13581 43.6391 6.41857 43.6392 6.70415C43.6393 6.98979 43.5831 7.27265 43.4737 7.53654C43.3644 7.80043 43.2041 8.04016 43.002 8.24203C42.7999 8.44389 42.56 8.60391 42.2959 8.71293C42.0319 8.82196 41.749 8.87784 41.4633 8.8774V8.88081Z",
    fill: "#CCCCCC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9336_80886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white",
    transform: "translate(0.5 0.461182)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9336_80886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.507,
    height: 82,
    fill: "white",
    transform: "translate(10.75 0.461182)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDoc);
export default __webpack_public_path__ + "static/media/myDoc.5e6f9a1d3aeea66e1253a85960f390d2.svg";
export { ForwardRef as ReactComponent };